// Pure helpers for WaterMeterGraphContainer's "Select graphs" selection.
// Kept dependency-free (no React / webpack aliases) so they can be unit-tested
// in isolation with `node --test`.
//
// Background (N-111): the Accumulated water input chart used to derive each
// checkbox's `checked` from the *computed chart payload* (`waterMeterData`),
// which was rebuilt from redux on every field refetch. A background refetch of
// the same field therefore silently reverted the user's ticks to the two
// hardcoded defaults. These helpers hold the user's intent (`selectedKeys`)
// separately from the derived chart data so a refetch can no longer overwrite
// the selection.

// The two series that are on by default: Baseline recommendation and
// Irrigation & Precipitation.
const DEFAULT_WATER_INPUT_KEYS = [
  'baseline_etc_by_kc_table',
  'irrigation_precipitation',
];

// Toggle a single series key in the current selection, preserving order and
// avoiding duplicates. Returns a new array (never mutates the input).
const toggleSelectionKey = (selectedKeys, key, isChecked) => {
  const current = Array.isArray(selectedKeys) ? selectedKeys : [];
  if (isChecked) {
    return current.includes(key) ? current.slice() : [...current, key];
  }
  return current.filter((k) => k !== key);
};

// Selection produced by the "Select all" checkbox: every rendered key when
// checked, an empty selection (clears the chart) when unchecked.
const selectAllSelection = (allKeys, isChecked) =>
  isChecked && Array.isArray(allKeys) ? allKeys.slice() : [];

// Decide the selection to use when the field-update effect runs. A genuinely
// different field resets to the two defaults (a fresh array); the same field
// being refetched returns the current selection unchanged (same reference, so
// callers can skip a needless state update).
const selectionForFieldUpdate = (
  prevFieldId,
  nextFieldId,
  currentSelection,
) => {
  if (nextFieldId !== prevFieldId) {
    return DEFAULT_WATER_INPUT_KEYS.slice();
  }
  return currentSelection;
};

module.exports = {
  DEFAULT_WATER_INPUT_KEYS,
  toggleSelectionKey,
  selectAllSelection,
  selectionForFieldUpdate,
};
